<template>
	<div class="gotop">
		<!-- -->
		<div class="NoMessage" v-if="$store.state.NoMessageNumber > 0">
			{{ $store.state.NoMessageNumber }}
		</div>
		<div class="customer" id="customer" @click="ServesClick">
			<img src="../../../../assets/channel/GoTop/customerBtn.png" alt="" width="24px" height="24px">
			<div class="KEFU">
				客服
			</div>
		</div>
		<div class="customerTime" id="customerTime" @click="customerTimeClick" @mouseout="customerTimemouseout"
			@mousemove="customerTimemousemove">
			<img src="../../../../assets/channel/GoTop/customerTime.png" alt="" width="24px" height="24px">
			<div class="Time">
				线上 服务 时间
			</div>
		</div>
		<transition name="el-zoom-in-center">
			<div class="TimeContext HoverCss" v-show="TimeDateFalg">
				<div class="title">
					9:30 - 12:00
				</div>
				<div class="TimeDate">
					13:00 - 18:30
				</div>
			</div>
		</transition>
		<div class="EnterpriseWechatBox customerTime" style="height: 116px;" id="EnterpriseWechat"
			@mouseout="EnterpriseWechatout" @mousemove="EnterpriseWechatmove">
			<img src="../../../../assets/channel/GoTop/EnterpriseWechat.png" alt="" width="24px" height="24px">
			<div class="EnterpriseWechat ">
				企业 微信
			</div>
		</div>
		<transition name="el-zoom-in-center">
			<div v-show="EnterpriseWechatFalg" class="EnterpriseWechatQRcode HoverCss">
				<img src="../../../../assets/channel/GoTop/QRcode12.png" alt="" width="150px" height="150px">
				<span>
					扫一扫，添加客服企业微信
				</span>
			</div>
		</transition>
		<div class="Top" v-if="isActive" id="Top" @click="Top">
			<img src="../../../../assets/channel/GoTop/topBtn.png" alt="" width="24px" height="24px">

		</div>
	</div>

</template>

<script>
	export default {
		components: {},
		props: {},
		data() {
			return {
				isActive: false,
				timer: null, //滚动时长
				TimeDateFalg: false,
				EnterpriseWechatFalg: false,
			}
		},
		created() {},
		mounted() {
			//  console.log(this.$store.state.NoMessageNumber,'totle');
			this.$nextTick(() => {
				this.$fishkefu.init()
				this.$fishkefu.Config()
			})
			window.addEventListener('scroll', this.handleScroll, true); // 监听（绑定）滚轮滚动事件
		},
		activated() {},
		updated() {},
		methods: {
			ServesClick() {
				this.$fishkefu.openSdk()
			},
			Top() {
				let top = document.documentElement.scrollTop || document.body.scrollTop;
				// 实现滚动效果
				this.timer = setInterval(() => {
					document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
					if (top <= 0) {
						clearInterval(this.timer);
					}
				}, 10);
			},
			customerTimeClick() {

			},
			customerTimemouseout() {
				this.TimeDateFalg = false
			},
			customerTimemousemove() {
				this.TimeDateFalg = true
			},
			EnterpriseWechatout() {
				this.EnterpriseWechatFalg = false
			},
			EnterpriseWechatmove() {
				this.EnterpriseWechatFalg = true
			},
			handleScroll() {
				//获取滚动距顶部的距离，显示
				let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				// console.log("scroll", scrollTop);
				//   滚动条距离顶部的距离
				if (scrollTop > 60) {
					this.isActive = true;
				} else {
					this.isActive = false;
				}
			}
		},
		computed: {},
		watch: {},
		destroyed() {
			window.removeEventListener('scroll', this.handleScroll); //离开页面需要移除这个监听的事件
			clearInterval(this.timer);
		}
	}
</script>
<style scoped lang='less'>
	.gotop {
		position: fixed;
		bottom: 200px;
		right: 10px;
		height: 400px;
		width: 48px;
		// background-color: red;
		z-index: 999;
		user-select: none;

		.NoMessage {
			background-color: rgb(243, 66, 66);
			width: 20px;
			height: 20px;
			border-radius: 50%;
			position: relative;
			top: 35px;
			left: 15px;
			color: #fff;
			text-align: center;
			line-height: 20px;
		}

		.customer {
			width: 100%;
			height: 120px;
			border-radius: 2px;
			// background: url("../../../../assets/channel/GoTop/comtomer.png") no-repeat 0
			//   0;
			border-radius: 100px 100px 100px 100px;
			opacity: 1;
			border: 1px solid rgba(99, 149, 249, 0.10000000149011612);
			background: #00266D;
			cursor: pointer;
			z-index: 99;
			font-size: 14px;
			color: #fff;

			img {
				position: relative;
				top: 40px;
				left: 13px;
			}

			.KEFU {
				position: relative;
				top: 40px;
				left: 11px;
			}
		}

		.EnterpriseWechatBox {
			.EnterpriseWechat {
				width: 30px;
				position: relative;
				top: 30px;
				left: 10px;
				// border: 1px solid red;
				line-height: 150%;
			}

			img {
				position: relative;
				top: 20px;
				left: 13px;
			}
		}

		.customerTime {
			width: 100%;
			height: 140px;
			border-radius: 2px;
			background: #00266D;
			border-radius: 100px 100px 100px 100px;
			opacity: 1;
			border: 1px solid rgba(99, 149, 249, 0.10000000149011612);
			// background: url("../../../../assets/channel/GoTop/comtomerTime.png") no-repeat 0
			//   0;
			// background-size: 90%;
			cursor: pointer;
			z-index: 99;
			font-size: 14px;
			color: #FFF;
			margin-top: 20px;

			img {
				position: relative;
				top: 30px;
				left: 13px;
			}

			.Time {
				width: 30px;
				position: relative;
				top: 30px;
				left: 10px;
				// border: 1px solid red;
				line-height: 150%;
			}
		}

		.HoverCss {
			background: #ffffff;
			box-shadow: -4px -4px 8px 1px rgba(255, 255, 255, 0.5),
				2px 6px 8px 1px rgba(4, 39, 89, 0.05999999865889549);
			border-radius: 4px 4px 4px 4px;
			opacity: 1;
			font-size: 14px;
			font-weight: normal;
			color: #424e66;
		}

		.EnterpriseWechatQRcode {
			position: absolute;
			right: 70px;
			bottom: -30px;
			width: 168px;
			height: 166px;
			background: #ffffff;
			box-shadow: 2px 6px 8px 1px rgba(4, 39, 89, 0.05999999865889549);
			border-radius: 4px 4px 4px 4px;
			opacity: 1;

			span {
				display: inline;
				font-size: 12px;
				position: relative;
				left: 15px;
				bottom: 12px;
			}

			img {
				margin-left: 11px;
				position: relative;
			}
		}

		.TimeContext {
			position: absolute;
			right: 70px;
			bottom: 150px;
			width: 114px;
			height: 60px;

			.title {
				width: 100%;
				// border: 1px solid red;
				margin-top: 10px;
				text-align: center;
			}

			.TimeDate {
				width: 100%;
				margin-top: 10px;
				text-align: center;
			}
		}

		.Top {
			width: 48px;
			height: 48px;
			border-radius: 48px;
			// border: 1px solid red;
			// background: url("../../../../assets/channel/GoTop/GoTop.png") no-repeat 0 0;
			// background-size: 100%;
			background: #00266D;
			border-radius: 100px 100px 100px 100px;
			opacity: 1;
			border: 1px solid rgba(99, 149, 249, 0.10000000149011612);
			position: relative;
			top: 35px;
			left: 1px;
			cursor: pointer;

			img {
				position: relative;
				top: 12px;
				left: 12px;
			}
		}
	}
</style>